import Breadcrumb from '@/src/components/Antd/Breadcrumb/Breadcrumb';
import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { getStocks, stocksInit } from '@/src/request/stock/stock';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  searchConditions as _searchConditions,
  randomNumber,
} from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { ProductItem } from 'src/types/common/product';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import css from './StockList.less';
import {
  breadcrumbData,
  columns,
  filterList,
  sortList,
  tabsConfig,
} from './StockListConfig';

const customerConvertQuery = (filter) => {
  const re: any = {};
  if (filter.supplierUuid) {
    if (filter.supplierUuid.length > 0) {
      re.supplierUuids = filter.supplierUuid.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};

const StockList = () => {
  const canAdd = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsStockIn,
        operation: EnumOperation.add_stock,
      }),
    ],
  });
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<ProductItem[]>([]);
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const [tabsActive, setTabsActive] = useState('');
  const [supplierList, setSupplierList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const _sortList = sortList({ getI18n });
  const defaultSearch = { ..._searchConditions, sort: _sortList[0] };
  const { clearSearchState, queryProps, search } = useQueries(
    filterList(supplierList, staffList, { getI18n }),
    _sortList,
    customerConvertQuery,
    defaultSearch,
  );

  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    setMappedSelectedKeys,
    setSelectedRowKeys,
  } = useSelectRows(products);

  // const exportFun = () => {
  //   console.log('Export');
  // };
  // const importFun = () => {
  //   console.log('Import');
  // };
  const addFun = () => {
    history.push('/stockEditor');
  };
  const buttonMenu = [];

  const clearTableState = () => {
    setSelectedRowKeys([]);
    setMappedSelectedKeys([]);
    setSelectedAll(false);
  };

  const tabChange = (activeKey) => {
    clearTableState();
    clearSearchState();
    setCurrent(0);
    setTabsActive(activeKey);
  };
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const getProduct = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    const data = search;
    getStocks(current * pageSize, pageSize, data).then((res) => {
      const { totalCount } = res;
      setTotal(totalCount);
      const products: ProductItem[] = res.results.map((i) => {
        return {
          ...i,
          key: randomNumber(),
        };
      });
      setProducts(products);
      setLoading(false);
    });
  };
  React.useEffect(() => {
    stocksInit(current * pageSize, pageSize, search).then((res) => {
      const {
        suppliers = [],
        staffs,
        stocks: { totalCount = 0, results = [] } = {},
      } = res;

      suppliers.forEach((item) => (item.key = item.uuid));
      setSupplierList(suppliers);
      setStaffList(staffs);
      setTotal(totalCount);
      setProducts(results);
    });
  }, []);

  useAfterDidMountEffect(() => {
    getProduct(() => void 0);
  }, [tabsActive, current]);
  useAfterDidMountEffect(() => {
    if (!current) {
      getProduct(() => {
        console.log('getProduct');
      });
    } else {
      setCurrent(0);
    }
  }, [pageSize, search]);

  const pageLayoutProps = {
    title: getI18n('stockIn.stock.list_pageLayoutProps_title'),
    addText: getI18n('stockIn.stock.list_pageLayoutProps_addText'),
    // exportFun,
    // importFun,
    addFun: canAdd ? addFun : null,
    tabChange,
    activeKey: tabsActive,
    tabsConfig: tabsConfig({ getI18n }),
  };

  return (
    <React.Fragment>
      <Breadcrumb
        className={css.breadcrumb}
        breadcrumbData={breadcrumbData({ getI18n })}
      />
      <ListPageLayout {...pageLayoutProps} tabChange={tabChange}>
        <GlobalTable
          hideBulkEditor
          id='ProductListTable'
          queryProps={queryProps}
          dataSource={products}
          columns={columns({ getI18n })}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          buttonMenu={buttonMenu}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          //mappedSelectedKeys={mappedSelectedKeys}
          hidePagination={total == 0}
          className={css.pageStyle}
          loading={loading}
        />
      </ListPageLayout>
    </React.Fragment>
  );
};

export default StockList;
